
import React from 'react';
import { preparednessStats } from '../../../mocks/preparedness';
import { Link } from 'react-router-dom';

export default function StatsBar() {
  // Defensive check: ensure the data exists and is an array
  const stats = Array.isArray(preparednessStats) ? preparednessStats : [];

  return (
    <div className="bg-white border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {stats.map((stat, index) => (
            <div
              key={stat.id ?? index}
              className="text-center"
            >
              <div className="inline-flex items-center justify-center w-16 h-16 bg-orange-100 rounded-full mb-4">
                <i className={`${stat.icon} text-3xl text-orange-600`}></i>
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-2">{stat.value}</div>
              <div className="text-lg font-semibold text-gray-700 mb-1">{stat.label}</div>
              <p className="text-sm text-gray-600">{stat.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 pt-6 border-t border-gray-100">
          <p className="text-xs text-gray-400 text-center leading-relaxed">
            Data provided by Ready.gov, Cal OES (California Governor&apos;s Office of Emergency Services), and
            Placer County Office of Emergency Services. Statistics are for informational purposes —
            please verify with official sources.
            <Link
              to="/data-sources"
              className="text-teal-600 hover:text-teal-700 font-medium ml-1 transition-colors"
            >
              View all sources
            </Link>
          </p>
          <p className="text-[11px] text-gray-300 text-center mt-1">
            <i className="ri-time-line mr-1"></i>Data last updated: January 28, 2025
          </p>
        </div>
      </div>
    </div>
  );
}
